import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
    }

    svg {
      height: 2rem;
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const Form = styled.form`
  padding-top: 3rem;

  h2 {
    margin: 1rem 0 0 0;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text};
    font-weight: lighter;
  }

  p {
    color: ${({ theme }) => theme.colors.text};
    margin: 0.5rem;
    font-size: 1.1rem;
  }

  .MuiInput-input {
    font-size: 1.2rem;
  }

  .containerName {
    width: 95%;
  }

  .containerAddress {
    display: grid;
    grid-template-columns: 16% 63% 11%;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0 0 0;

    .postalCodeInput {
      width: 100%;
    }

    .street {
      width: 100%;
    }

    .number {
      width: 100%;
    }
  }

  .containerComplement {
    width: 95%;
    margin: 1rem 0;

    .container {
      width: 100%;
    }
  }

  .buttonModal {
    display: flex;
    justify-content: flex-end;
    margin: 3rem 1rem 1rem 1rem;
  }

  .cnt-form {
    .input-form {
      padding-top: 21px;
    }

    .text-span {
      text-align: left;
      margin-top: 10px;
      font: normal normal 300 22px/23px Futura PT;
      letter-spacing: -0.55px;
      color: #8d8d8d;
      opacity: 1;
    }

    .dropdown {
      font: normal normal 300 22px/23px Futura PT;
      letter-spacing: -0.55px;
      color: #8d8d8d;
      opacity: 1;
      padding-top: 21px;

      .css-et6z77-MuiInputBase-root {
        width: 100%;
      }
      .css-1nrlq1o-MuiFormControl-root {
        width: 100%;
      }
    }

    .checkbox-options {
      display: flex;
      align-items: center;
      padding-top: 2rem;
      gap: 0.5rem;
      font: normal normal 300 22px/23px Futura PT;

      span {
        padding: 0;
      }
    }
  }
`;
